import React from 'react'
import '../ComStyles/NoMatch.scss'

function NoMatch() {
  return (
    <div>
        Sorry this page is not exist
    </div>
  )
}

export default NoMatch